<template>
  <div>
    <autocomplete
      v-model="model"
      :items="latinizedCompanies"
      :label="$t('select_company')"
      item-text="name"
      item-value="id"
      selectable-all
      clearable
      :loading="isLoading"
      chips
      return-object
      deletable-chips
      multiple
      prepend-item
      :label-min-selected="device.isMobile ? 2 : 5"
    >
      <template v-slot:prepend-item>
        <v-list-item
          @click="toggleAllCompanies"
          style="border-bottom: 1px solid rgba(0, 0, 0, 0.12)"
        >
          <v-list-item-action>
            <v-checkbox :value="model.length === companies.length"></v-checkbox>
          </v-list-item-action>
          <v-list-item-title>
            {{ $t("display_all") }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </autocomplete>
  </div>
</template>

<script>
import companyService from "@/services/company";
import hasModel from "@/mixins/hasModel";
import hasSnackbar from "@/mixins/hasSnackbar";

export default {
  name: "ReportMealsSelectAllCompanies",
  mixins: [hasModel, hasSnackbar],

  data() {
    return {
      companies: [],
      isLoading: false,
    };
  },

  methods: {
    toggleAllCompanies() {
      if (this.model.length) {
        this.model = [];
      } else {
        this.model = [...this.companies];
      }
    },

    async fetchCompanies() {
      this.isLoading = true;
      try {
        const response = await companyService.getCompanies();
        const rawCompanies = response.data || [];

        // Flatten companies including children
        this.companies = this.flattenCompanies(rawCompanies);

        // Automatically select the first company if available
        if (this.companies.length && !this.model.length) {
          this.model = [...this.companies];
        }
      } catch (error) {
        this.companies = [];
        this.showErrorSnackbar(error, this.$t("error_loading_companies"));
      } finally {
        this.isLoading = false;
      }
    },

    flattenCompanies(companies) {
      const flattened = [];

      companies.forEach((company) => {
        // Add the parent company only if contract = 1
        if (company.contract === 1) {
          flattened.push(company);
        }

        // Add children if they exist
        if (company.children && Array.isArray(company.children)) {
          // Recursively flatten children (in case of nested children)
          const childrenFlattened = this.flattenCompanies(company.children);
          flattened.push(...childrenFlattened);
        }
      });

      return flattened;
    },
  },

  computed: {
    latinizedCompanies() {
      return this.companies.map((company) => ({
        ...company,
        name: this.toLatin(company.name),
      }));
    },
  },

  mounted() {
    this.fetchCompanies();
  },
};
</script>

<style scoped>
/* Add any specific styles if needed */
</style>
